import { render, staticRenderFns } from "./ReleaseForm.vue?vue&type=template&id=6381c8bc"
import script from "./ReleaseForm.vue?vue&type=script&lang=js"
export * from "./ReleaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports